
import { ButtonIcon } from '@coachhubio/nova-button';
import { getBackgroundColor, getColor } from '@coachhubio/nova-colors';
import { Column, Row } from '@coachhubio/nova-flex';
import { marginBottom, marginTop, marginStart, paddingBottom } from '@coachhubio/nova-spaces';
import { Text } from '@coachhubio/nova-text';
import { getTextStyle } from '@coachhubio/nova-typography';
import { Link } from 'components/Link';
import styled from 'styled-components';

export const DashboardWrapper = styled.div<{ $height: string }>`
  display: flex;
  height: ${({ $height }) => $height};
`;

export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;

export const StyledColumn = styled(Column)`
  flex: 1;

  ${getBackgroundColor('background-color-default')}
`;

export const StyledMenuSection = styled(Text)`
  ${marginTop('m')}
  ${marginStart('s')}
  ${marginBottom('xs')}
  ${getTextStyle('text', 'xs', 'bold')}
  ${getColor('neutral60')};
`;

export const StyledMenuCollapsibleHeader = styled(Text)`
  ${marginStart('s')}
  ${marginBottom('none')}
  ${getTextStyle('text', 'xs', 'bold')}
  ${getColor('neutral45')}
  height: 24px;
`;

export const StyledMenuCollapsibleRow = styled(Row)`
  cursor: pointer;
`;

export const StyledMenuCollapsibleChevron = styled(ButtonIcon)`
  height: 24px;
  ${paddingBottom('base')}
`;

export const StyledCollapsibleMenu = styled(Column)<{ isExpanded: boolean }>`
  max-height: ${({ isExpanded }) => (isExpanded ? '1000px' : '0')};
  opacity: ${({ isExpanded }) => (isExpanded ? '1' : '0')};
  transition:
    max-height 0.2s ease-out,
    opacity 0.2s ease-out;
  overflow: hidden;
  will-change: max-height, opacity;
`;


